import { createPortal } from "react-dom";
import "../cre/cre.css";

export default function CreOrganisationModal({
  open,
  onClose,
  required = false,
  children,
}) {
  if (!open) return null;

  const modal = (
    <div
      className="cre-org-modal-root"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cre-org-modal-title"
    >
      {!required && onClose ? (
        <button
          type="button"
          className="cre-org-modal-backdrop"
          aria-label="Close"
          onClick={onClose}
        />
      ) : (
        <div
          className="cre-org-modal-backdrop cre-org-modal-backdrop--static"
          aria-hidden
        />
      )}
      <div className="cre-org-modal-panel">
        {!required && onClose ? (
          <button
            type="button"
            className="cre-org-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        ) : null}
        {children}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
